import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section id="cta" className="cta">
      <div className="cta__background"></div>
      <div className="container cta__container">
        <div className="cta__content animate-on-scroll">
          <h2 className="cta__title">
            まずは無料相談から
          </h2>
          <p className="cta__description">
            現状の課題をお聞かせください。<br />
            最適な支援プランをご提案いたします。
          </p>

          <div className="cta__features">
            <div className="cta__feature">
              <span className="cta__feature-icon">✓</span>
              <span>無料相談30分</span>
            </div>
            <div className="cta__feature">
              <span className="cta__feature-icon">✓</span>
              <span>オンライン対応可</span>
            </div>
            <div className="cta__feature">
              <span className="cta__feature-icon">✓</span>
              <span>秘密厳守</span>
            </div>
          </div>

          <button className="cta__button">
            無料相談を申し込む
            <span className="cta__button-arrow">→</span>
          </button>

          <p className="cta__note">
            📧 お問い合わせ後、24時間以内にご返信いたします
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;
